import { useContext, useState, useEffect } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import Put from "../../api/Put";
import { UPDATE_APPOINTMENT } from "../../api/Routes";
import { authContext } from "../../context/AuthContext";
import SimpleLoad from "../../loader/SimpleLoad";
import ComponentModalErrorSever from "../ComponentModalErrorSever";
import ModalSuccess from "../ModalSuccess";

export default function ModalChangeExpediente({openModalExp, setOpenModalExp, idAppointment, expediente, setExpediente}){
    const handleCloseInfo = () => setOpenModalExp(false);
    const [isSubmiting, setSubmitting] = useState(false)
    const [newExpediente, setNewExpediente] = useState('')
    const {auth} = useContext(authContext)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    } 
    const [errorServer, setErrorServer] = useState(null)

    useEffect(() => {
        if(openModalExp){
            setNewExpediente(expediente)
        }
    }, [openModalExp, expediente])

    const handleChangeExpediente = () => {
        setSubmitting(true)
        let d = {
            id: idAppointment,
            expediente: newExpediente   
        }
        Put({url: UPDATE_APPOINTMENT, data: d, access_token: auth.data.access_token ,header: true})
        .then(response=>{
            setSubmitting(false)
            setExpediente(newExpediente)
            setOpenModalExp(false)
            setShowSuccess(true)
        })
        .catch(error=>{
            setSubmitting(false)
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
        }) 
    }

    return (
        <>
            <Modal show={openModalExp} onHide={handleCloseInfo}>
                {isSubmiting && <SimpleLoad />}
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.Label>No. expediente</Form.Label>
                                <Form.Control 
                                    className="input-form"
                                    type="text"
                                    value={newExpediente}
                                    onChange={e=>setNewExpediente(e.target.value)}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="my-3">
                        <Col className="text-right">
                            <Button variant="secondary" onClick={handleCloseInfo}>Cancelar</Button>{' '}
                            <Button variant="primary" onClick={handleChangeExpediente}>Aceptar</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        <ModalSuccess show={showSuccess} setShow={setShowSuccess}/>
        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
        </>
        
    )
}